export const SECTION_MOVED_DOWN = 'down';
